// @flow

import { fetchRest } from "../../rest/rest";

export const FETCH_MESSAGES_SUCCESS = "state.blogs.FETCH_MESSAGES_SUCCESS";
export const FETCH_MESSAGES_ERROR = "state.blogs.FETCH_MESSAGES_ERROR";
export const SENT_MESSAGE = "state.blogs.SENT_MESSAGE";

export const fetchMessages = () => async dispatch => {
    try {
        const messages = await fetchRest("messages");
        dispatch({ type: FETCH_MESSAGES_SUCCESS, payload: messages });
    } catch (err) {
        err.message = `Unable to retrieve messages: ${err.message}`;
        console.log(err);
        dispatch({ type: FETCH_MESSAGES_ERROR, payload: err });
    }
};

export const sentMessage = message => async dispatch => {
    dispatch({ type: SENT_MESSAGE, payload: message });
};



// WEBPACK FOOTER //
// ./src/state/messages/actions.js